import React, { useState, useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import WelcomeAvatar from '../components/WelcomeAvatar';

const HomePage: React.FC = () => {
  const ELEVEN_LABS_API_KEY = process.env.REACT_APP_ELEVEN_LABS_API_KEY || 'sk_f9202cae774ea3d1383ae51c0ed5bb9cd7340090ea92f0e4';

  // Check URL params for Open Mode
  const [searchParams] = useSearchParams();
  const isOpenMode = searchParams.get('mode') === 'open';

  // Agent IDs
  const KNOWLEDGE_MODE_AGENT_ID = 'agent_6301k5dawazefnht8gj9v7c09zn5';
  const OPEN_MODE_AGENT_ID = 'agent_9601k5fc9k76etvb6eaed2r44fzk';

  // Select agent based on URL parameter
  const selectedAgentId = useMemo(() => {
    return isOpenMode ? OPEN_MODE_AGENT_ID : KNOWLEDGE_MODE_AGENT_ID;
  }, [isOpenMode]);

  const [pocStarted, setPocStarted] = useState(false);

  const handleStartPoc = useCallback(() => {
    setPocStarted(true);
  }, []);

  const handleStop = useCallback(() => {
    setPocStarted(false);
  }, []);

  return (
    <div className="App">
      <WelcomeAvatar
        apiKey={ELEVEN_LABS_API_KEY}
        agentId={selectedAgentId}
        autoPlay={pocStarted}
        onStartPoc={handleStartPoc}
        onStop={handleStop}
        pocStarted={pocStarted}
      />
    </div>
  );
};

export default HomePage;